import { Injectable } from '@angular/core';
import { Service } from './service.service';
import { Bibliografia } from '../model/bibliografia';

@Injectable()
export class BibliografiaService extends Service<Bibliografia> {

  protected getTable() {
    return 'bibliografia';
  }

  find() {
    return super.find(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/bibliografia.service.ts